const COMBINING_DIACRITICS_REGEX = new RegExp(
  '[' + String.fromCharCode(0x0300) + '-' + String.fromCharCode(0x036f) + ']',
  'g'
);

/**
 * Normaliza strings pra busca (remove acentos, minusculas, sem espacos nas bordas).
 * "previa"/"prévia" e "nos"/"nós" ficam equivalentes apos a normalizacao.
 */
export function normalizarTexto(texto: string): string {
  return texto
    .toLowerCase()
    .normalize('NFD')
    .replace(COMBINING_DIACRITICS_REGEX, '')
    .trim();
}

/**
 * Filtra uma lista pelo termo normalizado (ignora acentos/caixa) usando `matchFn`
 * pra decidir o que bate, e ordena o resultado com `sortFn`.
 */
export function filtrarLista<T>(
  lista: T[],
  termoBusca: string,
  matchFn: (item: T, termoNormalizado: string) => boolean,
  sortFn: (a: T, b: T) => number
): T[] {
  const termo = normalizarTexto(termoBusca);
  const resultado = !termo ? [...lista] : lista.filter(item => matchFn(item, termo));
  return resultado.sort(sortFn);
}

/**
 * Tenta achar um item pelo id salvo e, se nao achar (ou nao houver id), cai pro
 * fallback (nome/descricao). Cada chamador passa seus proprios matchers porque os
 * campos e a forma de comparar mudam por caso de uso -- so a estrutura
 * "tenta id, senao fallback" e comum.
 */
export function encontrarPorIdOuFallback<T>(
  lista: T[],
  matchPorId: (item: T) => boolean,
  matchPorFallback: (item: T) => boolean
): T | null {
  return lista.find(matchPorId) ?? lista.find(matchPorFallback) ?? null;
}
